import React from "react";
import Navbar from "./Navbar";
import Footer from "./Footer";
import FadeInOnScroll from "./FadeInOnScroll";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";

export default function OurSolutions2() {
  // 圆形图：缩放 + 轻微旋转
  const circleVariants = {
    hidden: { opacity: 0, scale: 0.9, rotate: -4 },
    visible: {
      opacity: 1,
      scale: 1,
      rotate: 0,
      transition: { duration: 0.45, ease: "easeOut" },
    },
  };

  const outerText =
    "text-white font-extrabold text-[13px] md:text-[15px] leading-[1.15] tracking-[0.12em] text-center";

  const centerText =
    "text-[#1e0b44] font-extrabold text-[12px] md:text-[14px] leading-[1.1] tracking-[0.10em] text-center";

  // 右侧文字：从右侧滑入
  const textVariants = {
    hidden: { opacity: 0, x: 24 },
    visible: {
      opacity: 1,
      x: 0,
      transition: { duration: 0.4, ease: "easeOut" },
    },
  };

  // 底部三卡片容器
  const cardsContainer = {
    hidden: {},
    visible: {
      transition: {
        staggerChildren: 0.14,
      },
    },
  };

  // 单个卡片
  const cardItem = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.4, ease: "easeOut" },
    },
  };

  return (
    <>
      <section className="relative overflow-hidden bg-gradient-to-br from-purple-50 via-white to-purple-100 text-[#1e0b44] py-24 px-6">
        <FadeInOnScroll>
          <div className="max-w-7xl mx-auto">
            {/* ===== 顶部 Title ===== */}
            <div className="text-center mb-16">
              <FadeInOnScroll>
                <h2 className="text-4xl md:text-5xl font-extrabold mb-4 bg-gradient-to-r from-[#6a2dd9] to-[#9a8dfc] bg-clip-text text-transparent">
                  DESIGNING YOUR FUTURE
                </h2>
                <p className="text-sm tracking-wider text-[#5e4ca8] font-semibold mb-28">
                  OUR CUSTOM SOLUTIONS
                </p>
              </FadeInOnScroll>
            </div>

            {/* ===== 中间：左图右文 ===== */}
            <motion.div
              className="grid md:grid-cols-2 gap-12 items-center mb-16 max-w-6xl mx-auto"
              initial={{ opacity: 0, y: 15 }}
              animate={{ opacity: 1, y: 0 }} // ✅ 不再依赖滚动，进入页面就淡入
              transition={{ duration: 0.35, ease: "easeOut" }}
            >
              {/* 左侧：圆形图（缩放+轻微旋转入场） */}
              <motion.div
                className="flex justify-center"
                variants={circleVariants}
                initial="hidden"
                animate="visible" // ✅ 改用 animate
              >
                <div className="relative w-[320px] h-[320px] md:w-[380px] md:h-[380px]">
                  {/* 外圈虚线圆 */}
                  <div className="absolute inset-[-32px] md:inset-[-38px] rounded-full border-4 border-dashed border-[#d8c9ff] opacity-60 pointer-events-none animate-spin-slow" />

                  {/* AI Consulting */}
                  <div className="absolute top-[26px] left-[0px] w-[160px] h-[160px] md:w-[190px] md:h-[190px] bg-[#6C3ECB] rounded-full flex items-center justify-center shadow-[0_18px_40px_rgba(30,11,68,0.12)]">
                    <div className={outerText}>
                      AI
                      <br />
                      CONSULTING
                    </div>
                  </div>

                  {/* IDC Consulting */}
                  <div className="absolute top-[26px] right-[0px] w-[160px] h-[160px] md:w-[190px] md:h-[190px] bg-[#C63D96] rounded-full flex items-center justify-center shadow-[0_18px_40px_rgba(30,11,68,0.12)]">
                    <div className={outerText}>
                      IDC
                      <br />
                      CONSULTING
                    </div>
                  </div>

                  {/* Managed Services */}
                  <div className="absolute bottom-[-10px] md:bottom-[-20px] left-1/2 -translate-x-1/2 w-[170px] h-[170px] md:w-[200px] md:h-[200px] bg-[#FF8A5C] rounded-full flex items-center justify-center shadow-[0_18px_40px_rgba(30,11,68,0.12)]">
                    <div className={outerText}>
                      MANAGED
                      <br />
                      SERVICES
                    </div>
                  </div>

                  {/* 中心：Custom Solutions */}
                  <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[105px] h-[105px] md:w-[125px] md:h-[125px] rounded-full bg-white/55 backdrop-blur-lg ring-1 ring-white/70 shadow-[0_16px_35px_rgba(30,11,68,0.12)] flex items-center justify-center">
                    <div className={centerText}>
                      CUSTOM
                      <br />
                      SOLUTIONS
                    </div>
                  </div>
                </div>
              </motion.div>

              {/* 右侧：文案描述（从右滑入） */}
              <motion.div
                className="space-y-4 text-lg font-semibold text-purple-900 tracking-wide text-center max-w-xl mx-auto"
                variants={textVariants}
                initial="hidden"
                animate="visible" // ✅ 改用 animate
              >
                <p>
                  At the heart of our innovation lies the AI Nova Ecosystem.
                  <br /> An integrated framework that combines high-performance
                  <br />
                  compute infrastructure, data and MLOps frameworks, and
                  <br />
                  platform enablement for real-world applications.
                </p>
                <p>
                  Through our strategic collaboration with global OTT
                  <br />
                  partners, AI Nova is bringing AI capabilities directly to
                  <br />
                  where people live, connect and build their communities.
                </p>
                <p>
                  AI NOVA turns infrastructure into actionable intelligence,
                  <br />
                  helping integrate AI into everyday operations.
                </p>
                <div className="flex justify-center">
                  <Link
                    to="/our-solutions"
                    className="cursor-pointer tracking-widest bg-purple-700 border border-purple-700 text-white font-semibold py-2 px-6 sm:px-8 md:py-3 md:px-10 rounded-md transition-all duration-300 ease-in-out hover:bg-purple-600 hover:border-purple-500 hover:shadow-lg hover:shadow-purple-300/60"
                  >
                    Explore More
                  </Link>
                </div>
              </motion.div>
            </motion.div>
          </div>
        </FadeInOnScroll>
      </section>

      <style>
        {`
          @keyframes spinSlow {
            from { transform: rotate(0deg); }
            to { transform: rotate(360deg); }
          }
          .animate-spin-slow {
            animation: spinSlow 18s linear infinite;
          }
        `}
      </style>
    </>
  );
}
